"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getById = getById;
async function getById(pdfBillRepo, id) {
    return await pdfBillRepo.getById(id);
}
